export default class AssetSelector {
  constructor(el) {
    this.el = el
    this.downloadLink = null
    this.selectClass = this.el.dataset.selectClass || ''
    this.buttonClass = this.el.dataset.buttonClass || 'w-full sm:w-auto button button--small'
    this.init()
    this.assetData = {}
    this.isValid = false
  }

  init() {
    try {
      this.assetData = JSON.parse(this.el.dataset.assetData)
      console.log(this.assetData.children)
      if (this.validateData(this.assetData)) {
        this.createSelect(this.assetData.children, 1)
      }
    } catch (error) {
      console.error('Error initializing AssetSelector:', error)
      this.assetData = {}
    }
  }

  validateData(data) {
    // Store the validation result for potential later use
    this.isValid = data &&
      typeof data === 'object' &&
      'id' in data &&
      'name' in data &&
      Array.isArray(data.children)
    return this.isValid
  }

  createSelect(options, level) {
    const select = document.createElement('select')
    select.dataset.level = level
    if (this.selectClass) {
      select.className = this.selectClass
    }

    const defaultOption = document.createElement('option')
    defaultOption.value = ''
    defaultOption.textContent = 'Select a model'
    select.appendChild(defaultOption)

    options.forEach((option) => {
      const opt = document.createElement('option')
      opt.value = option.name
      opt.textContent = option.name
      select.appendChild(opt)
    })

    select.addEventListener('change', (e) =>
      this.handleSelectChange(e, options, level))

    this.el.appendChild(select)
  }

  createAssetsSelect(assets, level) {
    const select = document.createElement('select')
    select.dataset.level = level
    if (this.selectClass) {
      select.className = this.selectClass
    }

    const defaultOption = document.createElement('option')
    defaultOption.value = ''
    defaultOption.textContent = 'Select the CAD file'
    select.appendChild(defaultOption)

    assets.flat()
      .forEach((asset) => {
        const opt = document.createElement('option')
        opt.value = asset.url
        // Extract filename from URL
        const filename = asset.url.split('/')
          .pop()
        opt.textContent = filename
        select.appendChild(opt)
      })

    select.addEventListener('change', (e) =>
      this.handleFileSelect(e))

    this.el.appendChild(select)
  }

  handleSelectChange(event, options, currentLevel) {
    const select = event.target
    const selectedOption = options.find((opt) =>
      opt.name === select.value)

    this.removeDeeper(currentLevel)

    if (selectedOption) {
      if (selectedOption.children && selectedOption.children.length > 0) {
        this.createSelect(selectedOption.children, currentLevel + 1)
      } else if (selectedOption.assets) {
        this.createAssetsSelect(selectedOption.assets, currentLevel + 1)
      }
    }
  }

  handleFileSelect(event) {
    const select = event.target

    if (this.downloadLink) {
      this.downloadLink.remove()
      this.downloadLink = null
    }

    if (select.value) {
      this.downloadLink = document.createElement('a')
      this.downloadLink.href = select.value
      this.downloadLink.target = ''
      this.downloadLink.download = ''
      this.downloadLink.textContent = 'Download File'
      this.downloadLink.className = this.buttonClass
      this.downloadLink.style.padding = ''

      // Add an event listener to change the text when clicked
      this.downloadLink.addEventListener('click', () => {
        this.downloadLink.textContent = 'Downloading...'
        setTimeout(() => {
          this.downloadLink.textContent = 'Download File'
        }, 3000)
      })

      this.el.appendChild(this.downloadLink)
    }
  }

  removeDeeper(level) {
    const selectsToRemove = Array.from(
      this.el.querySelectorAll('select[data-level]'),
    )
      .filter((s) =>
        parseInt(s.dataset.level, 10) > level)

    selectsToRemove.forEach((s) =>
      s.remove())

    if (this.downloadLink) {
      this.downloadLink.remove()
      this.downloadLink = null
    }
  }
}
